export class SaqueCopiaColaModel {
    accountId: string = '';
    paymentOptions : string[] = ['PIX'];
    person : SaqueCopiaColaPersonModel = new SaqueCopiaColaPersonModel();
    value: number = 0;
    endToEndId : string = '';
}

export class SaqueCopiaColaPersonModel
{
  cpf: string = '';
  email: string = '';
  pixKeyTypes: string = '';
  pixKey: string = '';
  name: string = '';
}
